import React, { useState } from 'react';
import { useAuth } from '../components/AuthContext'; 
import { useNavigate } from 'react-router-dom'; 

// IMPORTS DES COMPOSANTS MODULAIRES
import Sidebar from '../components/Sidebar'; // Composant existant
import Navbar from '../components/Navbar';   // Composant existant
import NotificationPanel from '../components/NotificationPanel'; // Composant existant
import EmployeeForm from '../components/EmployeeForm'; // Nouveau composant créé

const EmployeeCreation: React.FC = () => {
    const { user } = useAuth();
    const navigate = useNavigate();

    // État pour contrôler l'ouverture/fermeture du panneau de notifications
    const [isNotifPanelOpen, setIsNotifPanelOpen] = useState(false);

    if (!user) {
        navigate('/login', { replace: true });
        return null;
    }
    
    // NOTE: handleSubmit a été déplacé dans EmployeeForm.tsx

    return (
        <div className={`flex min-h-screen bg-base-200 ${isNotifPanelOpen ? 'overflow-hidden' : ''}`}>

            <Sidebar />

            <main className="flex-1 p-3 sm:p-4 md:p-6 overflow-y-auto">

                {/* Navbar utilise directement le user du AuthContext */}
                <Navbar onOpenNotifPanel={() => setIsNotifPanelOpen(true)} />

                {/* Début de la section reproduisant le même design */}
                <div className="flex flex-col gap-6">
                    <div className="flex justify-between items-center">
                        <h2 className="text-3xl font-extrabold text-base-content">Nouvel employé</h2>
                        <div className="text-sm text-base-content/70">
                            {/* Vous pouvez ajouter un compteur ou autre information ici si nécessaire */}
                        </div>
                    </div>
                    
                    <div className="py-2 sm:py-4">
                        <EmployeeForm />
                    </div>
                </div>
                {/* Fin de la section reproduisant le même design */}

            </main>
            
            <NotificationPanel 
                isOpen={isNotifPanelOpen} 
                onClose={() => setIsNotifPanelOpen(false)} 
            />
        </div>
    );
};

export default EmployeeCreation;